module.exports = __webpack_public_path__ + "98c9fad8fc01cfadf97204d47858e08b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/comcast_2021_chart.png
// module id = 1659
// module chunks = 0